import { Link } from 'react-router-dom';
import { company } from '../data/company';

const DatenschutzPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Datenschutzerklärung</h1>
        <p className="text-sm text-gray-500 mb-8">
          Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
        </p>

        <div className="prose prose-gray max-w-none">
          <h2 className="text-xl font-semibold mt-6 mb-3">1. Verantwortlicher</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Plattform ist:<br />
            <strong>{company.legalName}</strong><br />
            {company.street}<br />
            {company.zip} {company.city}<br />
            {company.country}<br />
            {company.representative && <>Vertreten durch: {company.representative}<br /></>}
            E-Mail: {company.email}
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
          <p>
            Wir erheben und verarbeiten personenbezogene Daten nur, soweit dies für die Bereitstellung 
            unserer Dienste erforderlich ist. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 
            lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">3. Social Media Integrationen</h2>
          <p>
            Unsere Plattform ermöglicht die Verbindung mit folgenden Social-Media-Diensten:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li><strong>TikTok:</strong> Bei der Verbindung mit TikTok werden folgende Daten verarbeitet:
              <ul className="list-circle pl-6 mt-2">
                <li>Grundlegende Profilinformationen (user.info.basic)</li>
                <li>Berechtigung zum Hochladen von Videos (video.upload)</li>
                <li>Berechtigung zum Veröffentlichen von Videos (video.publish)</li>
              </ul>
            </li>
            <li><strong>Facebook/Instagram:</strong> Seitenzugriff und Posting-Berechtigungen</li>
            <li><strong>LinkedIn:</strong> Profilinformationen und Posting-Berechtigungen</li>
            <li><strong>Pinterest:</strong> Bei der Verbindung mit Pinterest werden folgende Daten verarbeitet:
              <ul className="list-circle pl-6 mt-2">
                <li>Name und ID Ihres Pinterest-Kontos zur Anzeige der Verbindung (user_accounts:read)</li>
                <li>Liste Ihrer Pinnwände, um den Pin auf einer Ihrer Pinnwände zu speichern (boards:read, boards:write)</li>
                <li>Erstellen von Pins aus Beiträgen, die Sie selbst angelegt und freigegeben haben, und Abruf ihres Status (pins:write, pins:read)</li>
              </ul>
              Wir lesen keine Inhalte anderer Pinterest-Nutzer, werten keine Pinterest-Daten aus und geben
              sie nicht an Dritte weiter. Zugangstoken und die gewählte Pinnwand speichern wir, solange
              Pinterest verbunden ist. Trennen Sie Pinterest unter „Kanäle“, löschen wir den Zugangstoken
              sofort; bereits veröffentlichte Pins bleiben auf Pinterest, bis Sie sie dort löschen.
            </li>
          </ul>
          <p>
            Die Verbindung zu diesen Diensten erfolgt über OAuth 2.0. Dabei werden Access-Tokens 
            sicher in unserer Datenbank gespeichert und nur für die von Ihnen autorisierten Zwecke verwendet.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">4. Automatisierte Antworten auf Instagram-Kommentare (Kommentar→DM)</h2>
          <p>
            Wenn der Inhaber eines verbundenen Instagram-Business-Kontos eine Keyword-Regel
            aktiviert, verarbeiten wir Kommentare, die unter den eigenen Beiträgen dieses Kontos
            veröffentlicht werden. Verarbeitet werden dabei: Kommentartext, Kommentar-ID,
            Beitrags-ID sowie der Benutzername des Kommentierenden. Enthält ein Kommentar ein
            festgelegtes Schlüsselwort, sendet die Anwendung genau eine private Antwort an den
            Verfasser des Kommentars (Instagram Messaging API,
            Permission: <em>instagram_manage_messages</em>). Es werden keine unaufgeforderten
            Nachrichten versendet.
          </p>
          <p className="mt-3">
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse des
            Kontoinhabers an der Beantwortung an ihn gerichteter Kommentare). Reagiert der
            Kommentierende auf die Antwort und willigt ausdrücklich ein, speichern wir die
            Anfrage als Kontaktanfrage (Lead); bis dahin wird kein Einwilligungsstatus gesetzt.
            Ereignisdaten werden nach 90 Tagen gelöscht, Kontaktanfragen nach Zweckerfüllung.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">5. Zweck der Datenverarbeitung</h2>
          <p>Wir verarbeiten Ihre Daten für folgende Zwecke:</p>
          <ul className="list-disc pl-6 my-4">
            <li>Planung und automatische Veröffentlichung von Social-Media-Beiträgen</li>
            <li>Analyse und Optimierung Ihrer Social-Media-Profile</li>
            <li>Bereitstellung von KI-gestützten Content-Vorschlägen</li>
            <li>Verwaltung Ihres Redaktionsplans</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3">6. Speicherdauer</h2>
          <p>
            Ihre Daten werden nur so lange gespeichert, wie es für die Erfüllung der genannten Zwecke 
            erforderlich ist. OAuth-Tokens werden gelöscht, wenn Sie die Verbindung zu einem 
            Social-Media-Dienst trennen.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">7. Ihre Rechte</h2>
          <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
          <ul className="list-disc pl-6 my-4">
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
            <li>Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde (Art. 77 DSGVO), z.&nbsp;B. der Landesbeauftragten für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)</li>
          </ul>

          <h2 id="datenloeschung" className="text-xl font-semibold mt-6 mb-3">7a. Datenlöschung (Data Deletion)</h2>
          <p>
            Du kannst die Löschung all deiner Daten jederzeit selbst auslösen: in der App unter
            <strong> Einstellungen → Abschnitt „Datenschutz &amp; meine Daten" → „Konto &amp; Daten
            löschen"</strong> (Bestätigung durch Eintippen von „LÖSCHEN"). Alternativ genügt eine kurze E-Mail an
            {" "}<a href="mailto:schuchardt@foerderfuchs-bildung.de" className="text-orange-500 underline">schuchardt@foerderfuchs-bildung.de</a>.
            Wir entfernen daraufhin alle deine personenbezogenen Daten und die über verbundene
            Social-Media-Dienste (z.&nbsp;B. Facebook, Instagram) erhaltenen Daten binnen 30 Tagen
            vollständig aus unseren Systemen. Verbundene Kanäle kannst du zusätzlich jederzeit in den
            Einstellungen trennen, wodurch die zugehörigen Zugangstoken sofort widerrufen werden.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">8. Widerruf der Einwilligung</h2>
          <p>
            Sie können Ihre Einwilligung zur Datenverarbeitung jederzeit widerrufen. Gehen Sie dazu 
            in die Einstellungen und trennen Sie die Verbindung zum jeweiligen Social-Media-Dienst.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">9. Datensicherheit</h2>
          <p>
            Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten 
            gegen Manipulation, Verlust, Zerstörung oder Zugriff unberechtigter Personen zu schützen. 
            Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung 
            fortlaufend verbessert.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">10. Einsatz von Künstlicher Intelligenz, Auftragsverarbeiter &amp; Drittlandübermittlung</h2>
          <p>
            Zur Erstellung von Content-Vorschlägen (Texte, Hashtags, Bildideen, Bilder und Videos)
            sowie zum Betrieb der App setzen wir folgende Dienstleister als Auftragsverarbeiter
            (Art. 28 DSGVO) ein:
          </p>
          <ul className="list-disc pl-6 my-4">
            <li><strong>Anthropic PBC</strong> (USA) — KI-Texterstellung (Claude)</li>
            <li><strong>Groq, Inc.</strong> (USA) — KI-Texterstellung (Llama-Modelle)</li>
            <li><strong>fal.ai / Features &amp; Labels, Inc.</strong> (USA) — KI-Bild- und Videogenerierung</li>
            <li><strong>Stripe Payments Europe Ltd.</strong> (Irland) bzw. Stripe, Inc. (USA) — Zahlungsabwicklung</li>
            <li><strong>Resend</strong> (USA) — Versand von Transaktions-E-Mails</li>
          </ul>
          <ul className="list-disc pl-6 my-4">
            <li><strong>Keine Trainingsnutzung:</strong> Ihre Inhalte werden nicht zum Training der KI-Modelle verwendet.</li>
            <li><strong>Drittlandübermittlung:</strong> Soweit eine Verarbeitung in den USA erfolgt, ist diese durch EU-Standardvertragsklauseln (Art. 46 DSGVO) und ergänzende Garantien abgesichert; die Übermittlung an KI-Dienste erfolgt transient (keine dauerhafte Speicherung beim Anbieter).</li>
            <li><strong>Hosting &amp; Datenhaltung:</strong> EU-Infrastruktur.</li>
          </ul>
          <p>
            Verbinden Sie eigene Social-Media-Kanäle (z.&nbsp;B. Bluesky über ein von Ihnen
            hinterlegtes App-Passwort oder Facebook/Instagram per OAuth), übermitteln wir von Ihnen
            freigegebene Beiträge direkt an die jeweilige Plattform; dort gelten ergänzend die
            Datenschutzbestimmungen des jeweiligen Anbieters.
          </p>
          <p>
            Ein Auftragsverarbeitungsvertrag (AVV-Muster nach Art. 28 DSGVO) steht auf der Seite{' '}
            <Link to="/vertrauen" className="text-orange-600 hover:text-orange-700">Vertrauen &amp; DSGVO</Link>{' '}zum Download bereit.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">11. Kontakt</h2>
          <p>
            Bei Fragen zum Datenschutz können Sie uns jederzeit kontaktieren:<br />
            E-Mail: {company.privacyEmail}
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link to="/vertrauen" className="text-orange-600 hover:text-orange-700 font-medium">
            ← Mehr zu Vertrauen &amp; DSGVO
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
